import { render, staticRenderFns } from "./Nauczyciel.vue?vue&type=template&id=6f3970f0&scoped=true"
import script from "./Nauczyciel.vue?vue&type=script&lang=js"
export * from "./Nauczyciel.vue?vue&type=script&lang=js"
import style0 from "./Nauczyciel.vue?vue&type=style&index=0&id=6f3970f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3970f0",
  null
  
)

export default component.exports